import { render } from "./VsTh.vue?vue&type=template&id=105c0a92"
import script from "./VsTh.vue?vue&type=script&lang=js"
export * from "./VsTh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__